import { setProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/actions';
import { createSelectProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/selectors';
import { HabitatListItem } from '@/queries/habitats/types';
import store from '@/redux/store';

import { loadPage } from '../../helpers';
import { goToHabitatPage } from '../habitat/helpers';

export const getHabitatDescription = ({ habitat, loggedIn }: { habitat: HabitatListItem; loggedIn: boolean }) => {
  if (loggedIn) {
    return habitat.description;
  }
  return 'zoolife features live animal streams from the worlds’ top zoos, hosted by experts. Purchase a pass to explore all habitats on zoolife.';
};

export const getPrimaryButtonTitle = ({ loggedIn, isLocked }: { loggedIn: boolean; isLocked: boolean }) => {
  if (loggedIn) {
    return isLocked ? 'Unlock' : 'Visit';
  }
  return 'Buy a Pass';
};

export const onClickCardHandler = ({
  habitat,
  loggedIn,
  termsAccepted,
  openTermsModalAction,
  isLocked,
}: {
  habitat: HabitatListItem;
  loggedIn: boolean;
  termsAccepted: boolean;
  openTermsModalAction: () => void;
  isLocked: boolean;
}) => {
  if (loggedIn) {
    if (!termsAccepted) {
      openTermsModalAction();
    } else if (isLocked) {
      const defaultState = createSelectProductsPromptModalState(habitat._id)(store.getState());
      store.dispatch(
        setProductsPromptModalState({
          ...defaultState,
          entryPoint: 'map',
        }),
      );
    } else {
      goToHabitatPage(habitat.zoo?.slug, habitat.slug);
    }
  } else {
    loadPage('/signup');
  }
};
